// ─────────────────────────────────────────────────────────────────────────────
// useCharacterMovementConfig — cola React para o JSON de animação de caminhada.
//
// Devolve um REF estável (seguro de ler dentro de callbacks de render com deps
// `[]`, como o loop RAF do CombatGrid). Enquanto o fetch não volta, o ref já
// contém os defaults — o combate nunca fica sem config.
// ─────────────────────────────────────────────────────────────────────────────

import { type MutableRefObject, useEffect, useRef, useState } from 'react';
import type { CharacterMovementConfig } from './schema';
import {
  DEFAULT_CHARACTER_MOVEMENT,
  loadCharacterMovementConfig,
} from './characterMovement';

export function useCharacterMovementConfig(
  url?: string,
): MutableRefObject<CharacterMovementConfig> {
  const ref = useRef<CharacterMovementConfig>(DEFAULT_CHARACTER_MOVEMENT);
  const [, bump] = useState(0);

  useEffect(() => {
    let alive = true;
    loadCharacterMovementConfig(url).then((cfg) => {
      if (!alive) return;
      ref.current = cfg;
      bump((n) => n + 1); // força um redraw com os valores reais
    });
    return () => {
      alive = false;
    };
  }, [url]);

  return ref;
}
